import { useEffect, useState } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import GamePage from '../components/game/GamePage';

if (!document.getElementById('syne-font')) {
  const link = document.createElement('link');
  link.id = 'syne-font';
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800;900&display=swap';
  document.head.appendChild(link);
}

const ClueCuePage = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) { navigate('/'); } else { setCurrentUser(user); }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0d0d1a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.4)', fontFamily: "'Syne', sans-serif", fontSize: '15px' }}>
        Loading…
      </div>
    );
  }

  return <GamePage currentUser={currentUser} onLeaveToApp={() => navigate('/dashboard')} />;
};

export default ClueCuePage;